"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Label = void 0;
var _mui = require("@ori-ui/mui");
const Label = exports.Label = (0, _mui.styled)(_mui.Typography)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
